import client from '../client';
import type { Category, CreateCategoryInput, UpdateCategoryInput, CategorySortItem } from '../../types/category';
import type { ApiResponse } from '../../types/api';

export const categoriesApi = {
  list: async (storeId: string, hierarchical?: boolean) => {
    const res = await client.get<ApiResponse<{ categories: Category[] }>>(
      `/dashboard/${storeId}/categories`,
      { params: hierarchical ? { hierarchical: true } : undefined },
    );
    return res.data.data!;
  },

  get: async (storeId: string, categoryId: string) => {
    const res = await client.get<ApiResponse<{ category: Category }>>(
      `/dashboard/${storeId}/categories/${categoryId}`,
    );
    return res.data.data!;
  },

  create: async (storeId: string, data: CreateCategoryInput) => {
    const res = await client.post<ApiResponse<{ categoryId: string; category: Category }>>(
      `/dashboard/${storeId}/categories`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, categoryId: string, data: UpdateCategoryInput) => {
    const res = await client.patch<ApiResponse<{ category: Category }>>(
      `/dashboard/${storeId}/categories/${categoryId}`,
      data,
    );
    return res.data.data!;
  },

  delete: async (storeId: string, categoryId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/categories/${categoryId}`);
  },

  sort: async (storeId: string, categories: CategorySortItem[]): Promise<void> => {
    await client.post(`/dashboard/${storeId}/categories/sort`, { categories });
  },

  stats: async (storeId: string, categoryId: string) => {
    const res = await client.get<ApiResponse<any>>(`/dashboard/${storeId}/categories/${categoryId}/stats`);
    return res.data.data!;
  },
};
